import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { last, split } from 'es-toolkit/compat';

import { getModelTypeOptions } from 'api/modelTypes';
import { ModelType } from 'interfaces/modelType';

export const useModelTypeOptions = (params: UseQueryOptions<ModelType[], unknown, ModelType[], string[]> = {}) =>
  useQuery(['modelTypes'], () => getModelTypeOptions(), params);

const HASH_DATA_REGEX = /\?hash_data=.*$/;

export const stripModelToUrlHashData = (modelUrl: string | undefined | null): string =>
  modelUrl?.replace(HASH_DATA_REGEX, '');

export const modelIdFromModelUrl = (modelUrl: string | undefined | null): string | undefined => {
  const strippedUrl = stripModelToUrlHashData(modelUrl);
  return strippedUrl ? last(split(strippedUrl, '/')) : undefined;
};
